// extracted by mini-css-extract-plugin
module.exports = {"textRTL":"translations_textRTL__10RPm","imageLTR":"translations_imageLTR__2MTgH","imageRTL":"translations_imageRTL__3I6Vr"};